import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Logo from "../images/Logo.png";
import CoralReef from "../images/CoralReef.jpg";
import NetworkCanvas from "./NetworkCanvas";
import { forgotPassword } from "../service/ResetPasswordService";
import { errorMessage } from "../service/HttpErrors";

export default function ForgotPassword() {
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);
    const [sent, setSent] = useState(false);
    const [error, setError] = useState("");

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");
        setLoading(true);
        try {
            const res = await forgotPassword(email);
            if (res === true) {
                setSent(true);
            } else {
                setError("Could not send reset email. Please try again.");
            }
        } catch (err) {
            setError(errorMessage(err, "Could not send reset email. Please try again."));
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="auth-layout">
            {/* Left panel */}
            <div className="auth-panel" style={{ backgroundImage: `url(${CoralReef})` }}>
                <div className="auth-panel-overlay" />
                <NetworkCanvas />
                <div className="auth-panel-content">
                    <div className="auth-logo-wrap">
                        <img src={Logo} alt="Logo" className="auth-logo" />
                    </div>
                    <h2 className="auth-panel-title">DeepThought</h2>
                    <p className="auth-panel-sub">Research analytics for the modern scientist.</p>
                </div>
            </div>

            {/* Right form */}
            <div className="auth-form-side">
                <NetworkCanvas dark />
                <div className="auth-form-wrap">
                    {sent ? (
                        <>
                            <h1 className="auth-heading">Check your email</h1>
                            <p className="auth-sub">
                                We sent a password reset link to <strong>{email}</strong>. If you don't see it, check your spam folder.
                            </p>
                            <p className="auth-switch" style={{ marginTop: 24 }}>
                                <button className="auth-link auth-link-bold" onClick={() => navigate("/login")}>
                                    Back to Login
                                </button>
                            </p>
                        </>
                    ) : (
                        <>
                            <h1 className="auth-heading">Reset password</h1>
                            <p className="auth-sub">Enter your email and we'll send you a reset link.</p>

                            <form onSubmit={handleSubmit}>
                                <div className="auth-fields">
                                    <div className="auth-field">
                                        <label className="upload-label">Email</label>
                                        <input
                                            className="upload-input"
                                            type="email"
                                            placeholder="you@example.com"
                                            required
                                            value={email}
                                            onChange={e => { setEmail(e.target.value); setError(""); }}
                                        />
                                    </div>
                                </div>

                                {error && <p className="chpw-error">{error}</p>}

                                <button className="auth-submit-btn" type="submit" disabled={loading}>
                                    {loading ? "Sending..." : "Send Reset Link"}
                                </button>
                            </form>

                            <p className="auth-switch">
                                <button className="auth-link auth-link-bold" onClick={() => navigate("/login")}>
                                    Back to Login
                                </button>
                            </p>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
}
